import USER_ME from "./query.gql";
import { ScopeData } from "@/graphql/scopeData";

export interface GroupData {
  id: string;
  name: string;
}

export interface CompanyData {
  id: string;
  name: string;
}

export interface UserData {
  id: string;
  name: string;
  scopes: ScopeData[];
  group: GroupData;
  company: CompanyData;
}

export interface UserMeData {
  me: UserData;
}

export { USER_ME };
